export var ApiType;
(function (ApiType) {
    ApiType["Line"] = "line";
    ApiType["Batch"] = "batch";
})(ApiType || (ApiType = {}));
export var EventType;
(function (EventType) {
    EventType["Init"] = "init";
    EventType["Data"] = "data";
    EventType["End"] = "end";
    EventType["Error"] = "error";
    EventType["Pause"] = "pause";
})(EventType || (EventType = {}));
